import {ReactNode} from 'react';

import {AuthLayoutControls} from 'components';
import {BaseLayout} from 'layouts/Base';

type Props = {
    children: ReactNode,
    hasLogo?: boolean,
    hasTranslate?: boolean,
    hasFooter?: boolean
    dynamicHeader?: ReactNode;
}

export type AuthLayoutProps = Props;

export const AuthLayout: React.FC<Props> = ({children, dynamicHeader, hasLogo, hasTranslate, hasFooter}: Props) => (
    <BaseLayout
        hasLogo={hasLogo}
        hasTranslate={hasTranslate}
        hasFooter={hasFooter}
    >
        <AuthLayoutControls dynamicHeader={dynamicHeader}>
            {children}
        </AuthLayoutControls>
    </BaseLayout>
);